import { QueryClientProvider } from '@tanstack/react-query';

import { AuthProvider } from '../authentication/authContext';
import { PopupProvider } from '../components/confirmation';
import { ErrorBoundary } from '../components/errorBoundary';
import { SidebarProvider } from '../components/ui/sidebar';
import { ToastProvider } from '../components/ui/toast';
import { queryClient } from '../lib/react-query';
export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ToastProvider>
            <SidebarProvider className="h-full min-h-0">
              <PopupProvider>{children}</PopupProvider>
            </SidebarProvider>
          </ToastProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};
